<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <div style="width:76%;float:left;margin-bottom:10px">
        <el-input size="mini" placeholder="公司名称" v-model="listQuery.name" style="width:150px" @keyup.enter="getList"></el-input>
        <el-button size="mini" type="primary" @click="getList" style="margin-right:10px">搜索</el-button>
        <search @success="getList">
          <el-form style="margin:11px 0px 0px 15px;width:400px" class="styleForm">
            <el-form-item label="纳税人类型 ：" :label-width="formLabelWidth">   
              <selecttaxtype v-model:type="listQuery.type" @success="getList()"></selecttaxtype>
            </el-form-item>
            <el-form-item label="选择人员：" :label-width="formLabelWidth">
              <selectuser code="addCustomer" v-model:userId="listQuery.userId" @success="getList()"></selectuser>
            </el-form-item>
            <el-form-item label="所属区域 ：" :label-width="formLabelWidth"> 
              <selectcity v-model:citys="listQuery.districtCode" @success="getList()"></selectcity>
            </el-form-item>
          </el-form>
        </search>
      </div>
      <div style="width:20%;text-align:right;float:right">
        <el-button size="mini" type="primary" plain @click="customerExport">导出</el-button>
      </div>
      <el-tab-pane label="税款申报" name="seventh">
        <contentTable ref="clientList" :tabName="tabName" v-if="tabName == 'seventh'" :listQuery="listQuery"></contentTable>
      </el-tab-pane>
      <el-tab-pane label="零申报" name="sixth">
        <contentTable ref="clientList" :tabName="tabName" v-if="tabName == 'sixth'" :listQuery="listQuery"></contentTable>
        </el-tab-pane>
      <!-- <el-tab-pane label="不可申报" name="eighth">
        <contentTable ref="clientList" :tabName="tabName" v-if="tabName == 'eighth'" :listQuery="listQuery"></contentTable>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import selecttaxtype from "@/components/Screening/selecttaxtype";
import selectuser from "@/components/Screening/selectuser";
import selectcity from "@/components/Screening/selectcity";
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import contentTable from "./components/contentTable.vue";
import { assignCustomers } from "@/api/printSet"

export default {
  name: 'bookkeeping',
  components:{
    selecttaxtype,
    selectuser,
    selectcity,
    contentTable,
  },

  mounted () {
    const unWatch = this.$watch("$route", (newVal, oldVal) => {
      // console.log(newVal, oldVal);
    })
    // unWatch()
  },
  data() {
    return {
      period: '202202',
      formLabelWidth: '110px',
      listQuery: {
        page: 1,
        limit: 20,
        accountingType:2,
        status:'2'
      },
      userTotal: 2,
      activeName: "seventh",
      tabName:'seventh',
    }
  },
  created () {
    this.initBus()
  },
  methods: {
    initBus(){
      this.$bus.off("bookkeepingUpdate")
      this.$bus.on("bookkeepingUpdate", (val) => {
        this.getList()
      });
    },
    getList(){
      this.$refs.clientList.getList()
    },
    redirection() {
      this.$store.dispatch('tagsView/delCachedViewByName', "redirection")
      this.$router.push({
        path: "../../company/redirection.vue",
        name: "redirection"
      });
    },
    handleClick(tab, event) {
      this.listQuery.page = 1;
      this.listQuery.limit = 20;
      if (tab.props.label == "零申报") {
        this.tabName = tab.props.name
        this.listQuery.accountingType = 1
      } else if (tab.props.label == "税款申报") {
        this.tabName = tab.props.name
        this.listQuery.accountingType = 2
      } else if (tab.props.label == "不可申报") {
        this.tabName = tab.props.name
        this.listQuery.accountingType = 3
      }
    },
    customerExport(){
      let param = {
        query:this.listQuery
      }
      assignCustomers(param).then(res => {
        if (res.data.msg == "success") {
          window.open(res.data.data.url); 
        }
      })
    }
  },
  activated () {
    
  },
  setup() {
    onBeforeUnmount(()=>{
      console.log("2销毁")
    })
  },
}
</script>
<style lang="scss" scoped>
.home{
  padding: 10px;
  .header{
    margin-bottom: 10px;
    .right{
      float: right;
    }
    .input-search{
      width: 180px;
      margin-right: 5px;
    }
  }
  .img-ewm{
    width: 50px;
  }
}
.pagination{
  text-align: right;
  margin-right: 26px;
  margin-top: 16px;
}
.el-table{
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
.styleForm{
  .el-select{
    margin-left: 0px;
  }
}
</style>